export default __webpack_public_path__ + "files/datastory-0d15e3ff33ee4701c2f345c2f309c763.png";